import { MouseEvent, useEffect } from 'react'
import { useStores } from 'hooks/useStores'
import omit from 'lodash/omit'
import { observer } from 'mobx-react'
import { Tooltip, Marker as MarkerModule, useMap } from 'react-leaflet'
import { getMedia } from 'components/pages/DetailPage/utils'
import { ICarouseItem } from 'interfaces/listing'
import { IMedia } from 'interfaces/media'
import { IProperty } from 'interfaces/property'
import RoomCard from '../RoomCard'
import {
  createClusterCustomBlackMarker,
  createClusterCustomTealMarker,
  MarkerText,
  MarkerWrapper,
  Popup
} from './marker.styles'

interface IMarkerProps extends IProperty {
  changePosition: (lat: number, lng: number) => void
  media?: IMedia[]
}

const Marker = (props: IMarkerProps) => {
  const { id, lat, lng, fakeLat, fakeLng, lowestUnitPrice, media = [], changePosition } = props
  const map = useMap()
  const { listingStore } = useStores()
  const { selectedHouseId } = listingStore
  const cardImages: ICarouseItem[] = getMedia(media)

  function closePopupOnClick(event: MouseEvent<HTMLElement>): void {
    event.stopPropagation()
    map.closePopup()
  }

  function setSelectedMarker(): void {
    if (id) {
      listingStore.setSelectedHouseId(id)
      changePosition(fakeLat ?? lat, fakeLng ?? lng)
    }
  }

  function openPopup(): void {
    const markerElement: HTMLElement | null = document.querySelector('.leaflet-selected-marker')
    if (markerElement) {
      markerElement.click()
    }
  }

  useEffect(() => {
    if (selectedHouseId === id) {
      setTimeout(() => {
        openPopup()
      }, 0)
    }
  }, [selectedHouseId])

  return (
    <MarkerModule
      position={[fakeLat ?? lat, fakeLng ?? lng]}
      icon={selectedHouseId === id ? createClusterCustomTealMarker() : createClusterCustomBlackMarker()}
      eventHandlers={{
        click: setSelectedMarker
      }}
    >
      <Tooltip direction="center" offset={[-8, -2]} opacity={1} permanent>
        <MarkerText>${lowestUnitPrice}</MarkerText>
      </Tooltip>
      {selectedHouseId === id && (
        <Popup closeButton={false} closeOnClick={false} closeOnEscapeKey className="house-card-popup">
          <MarkerWrapper>
            <RoomCard popup closePopupOnClick={closePopupOnClick} images={cardImages} {...omit(props, 'images')} />
          </MarkerWrapper>
        </Popup>
      )}
    </MarkerModule>
  )
}

export default observer(Marker)
